import styled from 'styled-components'
import { background, border, boxModel, css } from '../util'
import { backgroundTypes, borderTypes, boxModelTypes, cssTypes } from '../types'

/**
 * @namespace TableDataCell
 * @desc Primitive styled-component 💅
 * @return {Function} React component
 */
const TableDataCell = styled.td`
  ${background};
  ${border};
  ${boxModel};
  ${css};
`

/**
 * @name defaultProps
 * @memberof TableDataCell
 * @desc Primitive's default properties
 */
TableDataCell.defaultProps = {
  borderWidth: [0],
  margin: [0],
  padding: [0],
  size: [0],
}

/**
 * @name propTypes
 * @memberof TableDataCell
 * @desc Primitive's prop type definitions
 */
TableDataCell.propTypes = {
  ...backgroundTypes,
  ...borderTypes,
  ...boxModelTypes,
  ...cssTypes,
}

/** @component */
export default TableDataCell
